(function(){'use strict';
function applyReveal(){
  ['.ma-pcard','.ma-rcard','.ma-ti'].forEach(function(s){
    document.querySelectorAll(s).forEach(function(el){
      if(!el.classList.contains('ma-reveal'))el.classList.add('ma-reveal');
    });
  });
  ['.ma-g4','.ma-g3','.ma-trust-row'].forEach(function(s){
    document.querySelectorAll(s).forEach(function(g){g.classList.add('ma-stagger');});
  });
  document.querySelectorAll('.ma-sec').forEach(function(sec){
    var eye=sec.querySelector('.ma-eye');
    var h=sec.querySelector('.ma-h');
    var p=sec.querySelector('.ma-p');
    if(eye&&!eye.hasAttribute('data-maa'))eye.classList.add('ma-reveal');
    if(h&&!h.hasAttribute('data-maa'))h.classList.add('ma-reveal');
    if(p&&!p.hasAttribute('data-maa'))p.classList.add('ma-reveal');
  });
  document.querySelectorAll('.ma-sec .ma-g2').forEach(function(grid){
    var c=grid.children;
    if(c[0]&&!c[0].classList.contains('ma-reveal'))c[0].classList.add('ma-reveal-l');
    if(c[1]&&!c[1].classList.contains('ma-reveal'))c[1].classList.add('ma-reveal-r');
  });
}
function initObserver(){
  if(!('IntersectionObserver' in window)){
    document.querySelectorAll('.ma-reveal,.ma-reveal-l,.ma-reveal-r,.ma-reveal-scale').forEach(function(el){el.classList.add('is-visible');});
    return;
  }
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){e.target.classList.add('is-visible');obs.unobserve(e.target);}
    });
  },{threshold:0.08,rootMargin:'0px 0px -48px 0px'});
  document.querySelectorAll('.ma-reveal,.ma-reveal-l,.ma-reveal-r,.ma-reveal-scale').forEach(function(el){obs.observe(el);});
}
function initParallax(){
  var bg=document.querySelector('.ma-hero-bg');
  if(!bg||window.matchMedia('(prefers-reduced-motion:reduce)').matches)return;
  var t=false;
  window.addEventListener('scroll',function(){
    if(!t){requestAnimationFrame(function(){bg.style.transform='translateY('+(window.pageYOffset*0.3)+'px)';t=false;});t=true;}
  },{passive:true});
}
function revealVisible(){
  var vh=window.innerHeight;
  document.querySelectorAll('.ma-reveal,.ma-reveal-l,.ma-reveal-r,.ma-reveal-scale').forEach(function(el){
    if(el.getBoundingClientRect().top<vh*0.96)el.classList.add('is-visible');
  });
}
function initCounters(){
  document.querySelectorAll('[data-ma-count]').forEach(function(el){
    var target=parseInt(el.getAttribute('data-ma-count'),10);
    var obs2=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting)return;
        obs2.unobserve(e.target);
        var start=null;
        (function step(ts){if(!start)start=ts;var p=Math.min((ts-start)/1800,1);var eased=1-Math.pow(1-p,3);el.textContent=Math.floor(eased*target);if(p<1)requestAnimationFrame(step);})(performance.now());
      });
    },{threshold:0.5});
    obs2.observe(el);
  });
}
function initMagnetic(){
  if(window.matchMedia('(hover:none)').matches)return;
  document.querySelectorAll('.ma-btn').forEach(function(btn){
    btn.addEventListener('mousemove',function(e){
      var r=btn.getBoundingClientRect();
      btn.style.transform='translate('+(((e.clientX-r.left)/r.width-0.5)*10)+'px,'+(((e.clientY-r.top)/r.height-0.5)*6)+'px) translateY(-2px)';
    });
    btn.addEventListener('mouseleave',function(){btn.style.transform='';});
  });
}
function initAddToCart(){
  document.querySelectorAll('[data-atc-form]').forEach(function(form){
    form.addEventListener('submit',function(e){
      var btn=form.querySelector('.ma-add-btn');
      if(!btn)return;
      var orig=btn.textContent;
      btn.textContent='Adding...';
      btn.disabled=true;
      setTimeout(function(){
        btn.textContent=orig;
        btn.disabled=false;
      },1800);
    });
  });
}
function boot(){
  applyReveal();initObserver();initParallax();initCounters();initMagnetic();initAddToCart();
  setTimeout(revealVisible,120);
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
